import {
  deleteContactApi,
  getContactsApi,
  getSingleContactApi,
} from "api/contacts";
import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  deleteContactFailure,
  deleteContactSuccess,
  getContactsFailure,
  getContactsSuccess,
  getSingleContactFailure,
  getSingleContactSuccess,
} from "./actions";
import {
  DELETE_CONTACT,
  GET_CONTACTS,
  GET_SINGLE_CONTACT,
} from "./actionTypes";
import { toast } from "react-toastify";

function* getContactsSaga() {
  try {
    const { data } = yield call(getContactsApi);
    yield put(getContactsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getContactsFailure(error?.response?.data?.errors?.[0]?.msg));
  }
}

function* getSingleContactSaga({ payload }) {
  try {
    const { data } = yield call(getSingleContactApi, payload);
    yield put(getSingleContactSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSingleContactFailure(error.response?.data?.message || error));
  }
}

function* deleteContactSaga({ payload }) {
  try {
    yield call(deleteContactApi, payload);
    yield put(deleteContactSuccess(payload));
    yield toast.success("تم الحذف بنجاح");
  } catch (error) {
    console.log(error);
    yield put(deleteContactFailure(error?.response?.data || error));
    yield toast.error(
      JSON.stringify(error.response.data.errors?.map((err) => err.msg))
    );
  }
}

export function* watchGetContacts() {
  yield takeEvery(GET_CONTACTS, getContactsSaga);
}

export function* watchSingleContact() {
  yield takeEvery(GET_SINGLE_CONTACT, getSingleContactSaga);
}

export function* watchDeleteContact() {
  yield takeEvery(DELETE_CONTACT, deleteContactSaga);
}

function* contactsSaga() {
  yield all([fork(watchGetContacts)]);
  yield all([fork(watchSingleContact)]);
  yield all([fork(watchDeleteContact)]);
}

export default contactsSaga;
